<template>
    <div v-if="dias_e.length === 0">
        <div class="p-4 mb-4 text-sm text-gray-700 bg-gray-100 rounded-lg dark:bg-gray-700 dark:text-gray-300" role="alert">
            <span class="font-medium">¡No existen datos que mostrar!</span> Intente Nuevamente.
        </div>
    </div>
    <div v-else>
        <highcharts :options="chartOptions" ></highcharts>   
    </div>
</template>
<script>
import { defineComponent } from 'vue';
import { Link } from '@inertiajs/inertia-vue3';
import { Chart } from 'highcharts-vue';
export default defineComponent ({
    name:"Chart",
    props:{
        dias_e: Array,
        dias_r : Array,
        proveedor : Array,
        cordon_o : Array,
        cordon_porciento: Array
    },
    components: { 
        highcharts:Chart,
        Link,
    },
    data() {
        return {
            chartOptions: {
                chart: {
                    type: 'bar'
                },
                title: {
                    text: 'Proveedor ' + this.proveedor.nombre,
                },
                subtitle: {
                    text: 'Desde Cordon ' + this.cordon_o.descripcion,
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: ''
                    }
                },
                xAxis: {
                    categories: this.cordon_porciento,
                },
                legend: {
                    reversed: true
                },
                plotOptions: {
                    series: {
                        stacking: 'normal'
                    }
                },
                tooltip: {
                    headerFormat: '<b>{point.x}</b><br/>',
                    pointFormat: '{series.name}: {point.y}<br/>Total Dia(s): {point.stackTotal}' + '</b>',
                },
                series: [
                    {
                        type: 'bar',
                        name: "Dia(s) de Entrega",
                        data: this.dias_e,
                    },
                    {
                        type: 'bar',
                        name: "Dia(s) de Recolección",
                        data: this.dias_r,
                    },
                ],
                credits: {
                    enabled: true,
                    text: 'Shipro'
                },
            }
        }
    }
});
</script>
    